import classNames from 'classnames';
import logoValentino from './../../imgs/logo-loading-valentino.gif';
import styles from './Loader.module.scss';

export interface LoaderProps {
	visible: boolean;
	loadingText?: string;
	showProgressBar?: boolean;
	loading?: boolean;
}

const Loader = (props: LoaderProps) => {
	return (
		<div
			data-testid='loader'
			className={classNames({
				[styles.ff_loader_overlay]: props.loadingText === 'undefined',
				[styles.ff_loader_overlay_hide]: !props.visible,
				[styles.ff_loader_overlay_ar]: !!props.loadingText,
				[styles.ff_loader_overlay_ar_hide]: !props.visible,
			})}
		>
			<div className={styles.ff_loader}>
				<img className={styles.ff_loader__img} src={logoValentino} alt={'loader'} />
				{props.loadingText && <span className={styles.ff_loader_loadingText}>{props.loadingText}</span>}
				{props.showProgressBar && <span className={styles.ff_loader_loadingText}>{props.loadingText}</span>}
			</div>
		</div>
	);
};

export default Loader;
